export const PROMPT_POPOVER_WIDTH_PX = 800;
export const PROMPT_POPOVER_HEIGHT_PX = 425;

/**
 * Display names for system prompt keys returned by the
 * `presentationSystemPrompts` endpoint. Only keys present here appear as
 * presets in the slide editor prompt popover; new backend keys are ignored
 * until they are added to this map.
 */
export const SYSTEM_PROMPT_DISPLAY_NAMES: Record<string, string> = {
  EXECUTIVE_SUMMARY: 'Executive summary',
};
